import React, { useEffect, useState, useMemo } from "react";
import { Drawer, Button, Alert } from "antd";
import { WarningIcon } from "components/Icons";
import SearchableTree from "components/SearchableTree/SearchableTree";

import "./AssetTypeDrawer.scss";
import { FullList, ShortList } from "./AssetTypeMessaging";

export default function AssetTypeDrawer({
  onClose,
  onSubmit,
  visible,
  defaultValue,
  treeData,
  children,
  eightyTwenty,
  ASSET_FAST_MOVERS_FEATURE_FLAG,
  resetAssetTypeRequired = false,
  invalidAssetTypeTree = []
}) {
  const [selectedItem, setSelectedItem] = useState();

  const invalidSystemBreadcrumb = useMemo(() => {
    if (invalidAssetTypeTree.length) {
      let breadcrumb = ''

      invalidAssetTypeTree.forEach((i, index) => {
        breadcrumb += i

        if (index !== invalidAssetTypeTree.length - 1) {
          breadcrumb += ' / '
        } 
      })

      return breadcrumb
    }

    return null
  }, [invalidAssetTypeTree])
 

  useEffect(() => {
    setSelectedItem(defaultValue);
  }, []);

  function onSearchableTreeChange(selectedTreeNode) {
    const [treeNode]= selectedTreeNode
    const newSelectedItem = {
      ...(selectedItem || {}),
      allowMultiple: treeNode?.allowMultiple || false,
      description: treeNode.titleString,
      tree: treeNode.tree,
      eliasID: treeNode.eliasID,
      legacyId: treeNode.legacyId,
      virtual: treeNode.virtual,
      nrm: treeNode.nrm,
      sfgCode: treeNode.sfgCode,
      knownAs: treeNode.knownAs,
    };
    setSelectedItem(newSelectedItem);
  }

  return (
    <Drawer
      placement="right"
      onClose={onClose}
      visible={visible}
      className="asset-type-drawer"
      forceRender
      closable={false}
    >
      {resetAssetTypeRequired && (
        <Alert
          className="assetType-error-box"
          message={(
            <>
              <p>{invalidSystemBreadcrumb}</p>
              <p>This asset type is not valid for this estate, please select the correct asset type.</p>
            </>
          )}
          showIcon
          icon={<WarningIcon className="alert-icon" />}
          type="error"
          onClose={() => {}}
        />
      )}
      {ASSET_FAST_MOVERS_FEATURE_FLAG ? eightyTwenty? <ShortList /> : <FullList /> : null}
      <SearchableTree
        onChange={onSearchableTreeChange}
        value={selectedItem?.description}
        searchType={'field'}
        label={"Select asset type"}
        defaultValue={defaultValue.eliasID}
        treeData={treeData}
        variant={"form"}
        type={'single'}
        searchLabel={"Search asset type..."}
        children={children}
      />
      <div className="form-buttons">
        <Button type="transparent" onClick={onClose}>
          Cancel
        </Button>
        <Button type="primary" onClick={() => onSubmit(selectedItem)}>
          Update
        </Button>
      </div>
    </Drawer>
  );
}
